import React from 'react';
import style from './ProductBrandsFilter.scss';
export const ProductBrandsFilter = ({ alphabetsInAscii: alphabetInAscii }) => (React.createElement(React.Fragment, null,
    React.createElement("h2", { className: style.allProductBrandsHeading }, "Kaikki tuotemerkit"),
    React.createElement("ol", { className: style.filterList },
        alphabetInAscii.map((val) => (React.createElement("li", { key: val, className: style.filterList__item },
            React.createElement("a", { href: `#tuotemerkit-${String.fromCharCode(val)}`, className: style.filterList__item__link }, String.fromCharCode(val))))),
        React.createElement("li", { key: '#', className: style.filterList__item },
            React.createElement("a", { href: "#tuotemerkit-#", className: style.filterList__item__link }, "#")))));
